import React from 'react';

export type NavButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    delay?: number | string;
    title?: string;
};

const NavButton: React.FC<NavButtonProps> = ({ delay = 0, title, children, className, ...rest }) => {
    const style = { ...rest.style, animationDelay: typeof delay === 'number' ? `${delay}ms` : delay } as React.CSSProperties;

    return (
        <button
            className={className}
            title={title}
            {...rest}
            style={style}
        >
            {children}
        </button>
    );
};

export default NavButton;
